module.exports = __webpack_public_path__ + "assets/img/aboutUS-module6-4.9674e089.jpg";